export enum StepType {
    Module = 'Module',

    /**
     * WorkflowDefineInput is the starting Module of every workflow
     */
    WorkflowDefineInput = 'WorkflowDefineInput',

    /**
     * ModuleDefineInput is the Define Input Module for a Module with a file as Input
     * (Will be treated the same way as WorkflowDefineInput)
     */
    ModuleDefineInput = 'ModuleDefineInput',

    /**
     * OldWorkflowStarter is the DefineInput Module of old workflows.
     * Will be treated the same way as WorkflowDefineInput (same component), but its
     * (Input-Parameter) key is always src_url.
     */
    OldWorkflowStarter = 'OldWorkflowStarter',

    /**
     * OldSingleFileUpload is the DefineInput of Modules (not the workflow) of old workflows.
     * Will be treated the same way as WorkflowDefineInput (same component), but its
     * (Input-Parameter) key is always src_url.
     * The difference between OldWorkflowStarter and OldSingleFileUpload that the first
     * MUST always be at index 0 of the workflow.
     */
    OldSingleFileUpload = 'OldSingleFileUpload',
}

export enum StepErrorType {
    ParamNotConnected = 'ParamNotConnected',
    NoFilesSelected = 'NoFilesSelected',
    OneOrMoreStaticParameterNotSet = 'OneOrMoreStaticParameterNotSet',
}
